<h3 i18n>Edit user</h3>
<ng-container *ngIf="navLinks$ | async; let navLinks">
    <nav mat-tab-nav-bar>
        <a mat-tab-link
            *ngFor="let link of navLinks"
            [routerLink]="link.path"
            routerLinkActive #rla="routerLinkActive"
            [active]="rla.isActive">
            {{link.label}}
        </a>
    </nav>

    <router-outlet></router-outlet>
</ng-container>
